import { render, staticRenderFns } from "./tbt-picker.vue?vue&type=template&id=72be8e97&scoped=true"
import script from "./tbt-picker.vue?vue&type=script&lang=ts"
export * from "./tbt-picker.vue?vue&type=script&lang=ts"
import style0 from "./tbt-picker.vue?vue&type=style&index=0&id=72be8e97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be8e97",
  null
  
)

export default component.exports